import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileNav from '../components/MobileNav';
import SearchPopup from '../components/SearchPopup';

const Contact = () => {
  useEffect(() => {
    // Any JS plugins that rely on DOM can be initialized here if needed
    // Footer widget (Twitter) carousel (guarded for SPA + ESLint no-undef)
    const $jq = window && window.jQuery ? window.jQuery : null;
    if (
      $jq &&
      $jq('.footer-widget__carousel').length &&
      typeof $jq('.footer-widget__carousel').owlCarousel === 'function' &&
      !$jq('.footer-widget__carousel').hasClass('owl-loaded')
    ) {
      $jq('.footer-widget__carousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 7000,
        responsive: { 0: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1320: { items: 1 } }
      });
    }

    // No dropdown plugin needed since Service Type is a plain input now.
  }, []);

  return (
    <>
      {/* Utility overlays expected by template */}
      <MobileNav />
      <SearchPopup />

      {/* Custom cursors */}
      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      <div className="page-wrapper">
        <Header />

        {/* Sticky header placeholder */}
        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>

        {/* Page Header Start */}
        <section className="page-header">
          <div className="page-header__bg" style={{ backgroundImage: 'url(assets/images/5.jpg)' }}></div>
          <div className="page-header__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/page-header-shape-bg.png)' }}></div>
          <div className="page-header__shape-1 float-bob-x">
            <img src="assets/images/shapes/page-header-shape-1.png" alt="" />
          </div>
          <div className="page-header__shape-2 float-bob-y">
            <img src="assets/images/shapes/page-header-shape-2.png" alt="" />
          </div>
          <div className="container">
            <div className="page-header__inner">
              <h2>Contact</h2>
              <div className="thm-breadcrumb__box">
                <ul className="thm-breadcrumb list-unstyled">
                  <li><a href="/">Home</a></li>
                  <li><span className="fas fa-angle-right"></span></li>
                  <li>Contact</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Page Header End */}

        {/* Contact Page Start */}
        <section className="contact-page">
          <div className="contact-page__shape-1 float-bob-y">
            <img src="assets/images/shapes/contact-page-shape-1.png" alt="" />
          </div>
          <div className="contact-page__shape-2 float-bob-x">
            <img src="assets/images/shapes/contact-page-shape-2.png" alt="" />
          </div>
          <div className="container">
            <div className="section-title text-center sec-title-animation animation-style1">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">Contact Rayyan Aid</span>
              </div>
              <h2 className="section-title__title title-animation">Join With Us To Volunteer<br /> <span>Contact Now!</span></h2>
            </div>
            <div className="contact-page__inner">
              <form
                className="contact-form-validated contact-page__form"
                action="http://127.0.0.1:8000/assets/inc/sendemail.php"
                method="post"
                noValidate
              >
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="contact-page__input-box">
                      <input type="text" name="name" placeholder="Your Name" required />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="contact-page__input-box">
                      <input type="email" name="Email" placeholder="Email Address" required />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="contact-page__input-box">
                      <input type="text" name="Phone" placeholder="Phone Number" required />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="contact-page__input-box">
                      <input type="text" name="ServiceType" placeholder="Service Type" />
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="contact-page__input-box text-message-box">
                      <textarea name="message" placeholder="Message"></textarea>
                    </div>
                    <div className="contact-page__btn-box">
                      <button type="submit" className="thm-btn">
                        <span className="thm-btn-text">Send a message</span>
                        <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div className="result"></div>
            </div>
          </div>
        </section>
        {/* Contact Page End */}

        {/* Contact Three Start */}
        <section className="contact-three">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-7">
                <div className="contact-three__left">
                  <iframe
                    title="Rayyan Aid Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4562.753041141002!2d-118.80123790098536!3d34.152323469614075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e82469c2162619%3A0xba03efb7998eef6d!2sCostco+Wholesale!5e0!3m2!1sbn!2sbd!4v1562518641290!5m2!1sbn!2sbd"
                    className="contact-three__google-map"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5">
                <div className="contact-three__right">
                  <ul className="contact-three__contact-list list-unstyled">
                    <li>
                      <div className="icon">
                        <span className="icon-pin"></span>
                      </div>
                      <div className="content">
                        <h4>Address</h4>
                        <p>Abuja, Nigeria</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-email"></span>
                      </div>
                      <div className="content">
                        <h4>Email Address</h4>
                        <p><a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a></p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-call"></span>
                      </div>
                      <div className="content">
                        <h4>Phone number</h4>
                        <p><a href="tel:07063653772">07063653772</a></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Three End */}

        <Footer />
      </div>
    </>
  );
};

export default Contact;
